var _path, _g, _path2, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.268,
    height: 28.268,
    viewBox: "0 0 28.268 28.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M0-682.665H28.268V-654.4H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_8327",
    "data-name": "Path 8327",
    transform: "translate(-17.46 -70.976)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.258,93.686H23.93A3.93,3.93,0,0,1,20,89.756V79.93A3.93,3.93,0,0,1,23.93,76H39.258a3.93,3.93,0,0,1,3.93,3.93v9.826A3.93,3.93,0,0,1,39.258,93.686Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.25846099853516 93.68635559082031 C 41.42913055419922 93.68635559082031 43.18877029418945 91.92670440673828 43.18877029418945 89.75604248046875 L 43.18877029418945 79.93027496337891 C 43.18877029418945 77.7596435546875 41.42912292480469 76.00000762939453 39.25846099853516 76.00000762939453 L 23.9302921295166 76.00000762939453 C 21.75964164733887 76.00000762939453 19.99999046325684 77.7596435546875 19.99999046325684 79.93027496337891 L 19.99999046325684 89.75604248046875 C 19.99999046325684 91.92670440673828 21.75964164733887 93.68635559082031 23.9302921295166 93.68635559082031 L 39.25846099853516 93.68635559082031 M 39.25846099853516 96.016357421875 L 23.9302921295166 96.016357421875 C 20.47835159301758 96.016357421875 17.66999053955078 93.20799255371094 17.66999053955078 89.75604248046875 L 17.66999053955078 79.93027496337891 C 17.66999053955078 76.47835540771484 20.47835159301758 73.67000579833984 23.9302921295166 73.67000579833984 L 39.25846099853516 73.67000579833984 C 42.71041107177734 73.67000579833984 45.51877212524414 76.47835540771484 45.51877212524414 79.93027496337891 L 45.51877212524414 89.75604248046875 C 45.51877212524414 93.20799255371094 42.71041107177734 96.016357421875 39.25846099853516 96.016357421875 Z",
    stroke: "none",
    fill: "#09c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8328",
    "data-name": "Path 8328",
    d: "M100,156l6.275,6.471a1.965,1.965,0,0,0,2.779,0L115.328,156",
    transform: "translate(-93.53 -147.046)",
    fill: "none",
    stroke: "#09c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.33
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_441",
    "data-name": "Line 441",
    y1: 4.913,
    x2: 4.716,
    transform: "translate(6.47 13.867)",
    fill: "none",
    stroke: "#09c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_442",
    "data-name": "Line 442",
    x2: 4.716,
    y2: 4.913,
    transform: "translate(17.082 13.867)",
    fill: "none",
    stroke: "#09c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.3834a363c4da9af5e08f5286a25dac57.svg";
export { ForwardRef as ReactComponent };